module.exports = __webpack_public_path__ + "media/images/freelogodesign1-ec5c97e9e808653fe84e65d1abf04ad0.png";